import URL from '@/tools/url';
import _toInteger from 'lodash/toInteger';
import _find from 'lodash/find';
import _get from 'lodash/get';
import _head from 'lodash/head';
import _filter from 'lodash/filter';
import EventBus from '@/event-bus';
import Products from '@/products';
import createStorage from '@/storage';

const Store = createStorage({ name: 'turbo' });

var Turbo = function() {
  if (URL.location.pathname != '/cart_items') {
    return;
  }

  this.act = URL.getKeyValue('act');
  this.clickId = URL.getKeyValue('click_id');
  this.variantId = _toInteger(URL.getKeyValue('variant_id'));
  this.inited = false;

  EventBus.subscribe('update_items:insales:cart', function(eventData) {
    if (this.inited) {
      return;
    }
    this.inited = true;

    Store.getItem('click_id')
      .then(function(id) {
        if (id != this.clickId && this.act == 'add_to_cart') {
          this._emitAdd(eventData);
        }
      }.bind(this))
      .then(function() {
        Store.setItem('click_id', this.clickId);
      }.bind(this));
  }.bind(this));
};

Turbo.prototype._emitAdd = function(order) {
  var _productId = _get(
    _head(
      _filter(order.order_lines, function(order_line) {
        return order_line.id == this.variantId;
      }.bind(this))
    ),
    'product.id'
  );

  Products.get(_productId)
    .then(function(product) {
      var _variant = _find(product.variants, { id: this.variantId });
      var _items = {};

      _items[this.variantId] = 1;

      EventBus.publish('add_items:insales:cart', Object.assign({ action: { items: _items } }, _variant));
    }.bind(this));
};

export default Turbo;
